module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/qa/female_medical_team-70bfd5daa74bac91d85c72dc8f1f2326.png";